import api from './api'

export const apiManagementService = {
  // Stats
  getStats: async () => {
    const response = await api.get('/ext-admin/stats')
    return response.data
  },

  // Clients
  getClients: async () => {
    const response = await api.get('/ext-admin/clients')
    return response.data
  },

  createClient: async (data) => {
    const response = await api.post('/ext-admin/clients', data)
    return response.data
  },

  updateClient: async (id, data) => {
    const response = await api.put(`/ext-admin/clients/${id}`, data)
    return response.data
  },

  deleteClient: async (id) => {
    const response = await api.delete(`/ext-admin/clients/${id}`)
    return response.data
  },

  regenerateKey: async (id) => {
    const response = await api.post(`/ext-admin/clients/${id}/regenerate-key`)
    return response.data
  },

  // Logs
  getLogs: async (params = {}) => {
    const response = await api.get('/ext-admin/logs', { params })
    return response.data
  },
}
